export default __webpack_public_path__ + "static/arrow-blue-9bb94388a15d0eb3f5a662e54fed63b4.png";